import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";

const ContactBlockDsfr = (props) => {
  const { leftChild, rightChild } = props;

  return (
    <Grid container columns={10}>
      <Grid
        size={{ xs: 12, lg: 4 }}
        sx={{
          px: { xs: 2, lg: 5 },
          py: { xs: 4, lg: 5 },
          border: "1px solid var(--border-default-blue-france)",
          bgcolor: "var(--background-alt-blue-france)",
        }}
      >
        {leftChild}
      </Grid>
      <Grid
        size={{ xs: 12, lg: 6 }}
        sx={{
          position: "relative",
          px: { xs: 2, lg: 5 },
          py: { xs: 4, lg: 5 },
          border: "1px solid var(--border-default-blue-france)",
          borderLeftWidth: { xs: "1px", lg: 0 },
          borderTopWidth: { xs: 0, lg: "1px" },
        }}
      >
        {rightChild}
      </Grid>
    </Grid>
  );
};

ContactBlockDsfr.propTypes = {
  leftChild: PropTypes.node.isRequired,
  rightChild: PropTypes.node.isRequired,
};

export default ContactBlockDsfr;
